/**
 * @generated SignedSource<<ce55645b2c9d866cf8b7c210cb8849ed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useFacilityAllowsRefunds_facility$data = {
  readonly squarePosConfiguration: {
    readonly allowWhooshRefunds: boolean;
  } | null | undefined;
  readonly " $fragmentType": "useFacilityAllowsRefunds_facility";
};
export type useFacilityAllowsRefunds_facility$key = {
  readonly " $data"?: useFacilityAllowsRefunds_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"useFacilityAllowsRefunds_facility">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useFacilityAllowsRefunds_facility",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SquarePosConfiguration",
      "kind": "LinkedField",
      "name": "squarePosConfiguration",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowWhooshRefunds",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
};

(node as any).hash = "5f90d663ac095deb6740490cde8c5028";

export default node;
